import { privateApi } from '../../api';
import DashboardItem from './DashboardItem';
import { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { BiMessageSquareError } from 'react-icons/bi';
import { BiCategory } from 'react-icons/bi';
import { FaUsers, FaBlog } from 'react-icons/fa';
import { FaRegUser } from 'react-icons/fa';
import { IoChatboxEllipsesOutline } from 'react-icons/io5';
import { LuShoppingCart } from 'react-icons/lu';
import { MdOutlineStorefront } from 'react-icons/md';
import { RiChatNewLine } from 'react-icons/ri';
import { RiGalleryFill } from 'react-icons/ri';
import { SiBrandfolder } from 'react-icons/si';

const Dashboard = () => {
      const [orders, setOrders] = useState([]);
      const [loading, setLoading] = useState(false);
      const [totalUsers, setTotalUsers] = useState(0);
      const [totalProducts, setTotalProducts] = useState(0);
      const [totalBlogs, setTotalBlogs] = useState(0);
      const [totalProductEnquiry, setTotalProductEnquiry] = useState(0);
      const [totalBanners, setTotalBanners] = useState(0);
      const [totalTestimonials, setTotalTestimonials] = useState(0);
      const [totalContactRequests, setTotalContactRequests] = useState(0);
      const [totalCandidates, setTotalCandidates] = useState(0);
      const [totalDealers, setTotalDealers] = useState(0);
      const [totalOrders, setTotalOrders] = useState(0);
      const [totalBrands, setTotalBrands] = useState(0);
      const [totalCategories, setTotalCategories] = useState(0);

      const loadData = async () => {
            setLoading(true);

            await privateApi
                  .get(`/dashboard`)
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setOrders(response.data.orders);
                              setTotalUsers(response.data.totalUsers);
                              setTotalProductEnquiry(
                                    response.data.totalProductEnquiry
                              );
                              setTotalProducts(response.data.totalProducts);
                              setTotalBlogs(response.data.totalBlogs);
                              setTotalBanners(response.data.totalBanners);
                              setTotalCandidates(response.data.totalCandidates);
                              setTotalContactRequests(
                                    response.data.totalContactRequests
                              );
                              setTotalTestimonials(
                                    response.data.totalTestimonials
                              );
                              setTotalDealers(response.data.totalDealers);
                              setTotalOrders(response.data.totalOrders);
                              setTotalBrands(response.data.totalBrands);
                              setTotalCategories(response.data.totalCategories);
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });

            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row className="g-3">
                        <DashboardItem
                              title="Total Products"
                              total={totalProducts}
                              link="/dashboard/products"
                              icon={<MdOutlineStorefront />}
                              permission="product-list"
                        />
                        <DashboardItem
                              title="Total Brand"
                              total={totalBrands}
                              link="/dashboard/brands"
                              icon={<SiBrandfolder />}
                              permission="brand-list"
                        />
                        <DashboardItem
                              title="Total Category"
                              total={totalCategories}
                              link="/dashboard/categories"
                              icon={<BiCategory />}
                              permission="brand-list"
                        />
                        <DashboardItem
                              title="Total Banner"
                              total={totalBanners}
                              link="/dashboard/banners"
                              icon={<RiGalleryFill />}
                              permission="banner-list"
                        />
                        <DashboardItem
                              title="Total Testimonials"
                              total={totalTestimonials}
                              link="/dashboard/testimonials"
                              icon={<IoChatboxEllipsesOutline />}
                              permission="testimonial-list"
                        />
                        <DashboardItem
                              title="Total Orders"
                              total={totalOrders}
                              link="/dashboard/orders"
                              icon={<LuShoppingCart />}
                              permission="order-list"
                        />
                        <DashboardItem
                              title="Total Blogs"
                              total={totalBlogs}
                              link="/dashboard/blogs"
                              icon={<FaBlog />}
                              permission="blog-list"
                        />
                        <DashboardItem
                              title="Total Product Enquiry"
                              total={totalProductEnquiry}
                              link="/dashboard/product_enquiries"
                              icon={<RiChatNewLine />}
                              permission="product-enquiry-list"
                        />
                        <DashboardItem
                              title="Total Contact Request"
                              total={totalContactRequests}
                              link="/dashboard/contact/requests"
                              icon={<BiMessageSquareError />}
                              permission="contact-request-list"
                        />
                        <DashboardItem
                              title="Total Candidates"
                              total={totalCandidates}
                              link="/dashboard/candidates"
                              icon={<FaUsers />}
                              permission="candidate-list"
                        />
                        <DashboardItem
                              title="Total Dealers"
                              total={totalDealers}
                              link="/dashboard/dealers"
                              icon={<FaRegUser />}
                        />
                        <DashboardItem
                              title="Total Users"
                              total={totalUsers}
                              link="/dashboard/users"
                              icon={<FaRegUser />}
                              permission="user-list"
                        />
                  </Row>
            </>
      );
};

export default Dashboard;
